import { defineComponent } from "vue";
import moment from "moment";
import { Container } from "aurelia-dependency-injection";

import { PatientService } from "../../../services/patient.service";
import { IPatientDialogOptions, IUploadPatientDocumentQuery } from "../../vue-interfaces/i-get-patient";
import { IGetPatientAdmissionPeriods } from "../../vue-interfaces/i-patient";

import PatientDocuments from "../../../pages-vue/CreateReferral/CreateReferralHosPal/components/PatientDocuments/PatientDocuments.vue";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        PatientDocuments
    },

    data() {
        return {
            _patientsService: null as PatientService,
            patientDocuments: null,
            dialogReference: this.dialogRef as any,
            options: {
                title: "",
                patientId: null,
                isEditPatient: false,
                providerId: "",
                application: null,
                accountId: ""
            } as IPatientDialogOptions,
            emptyGuid: "00000000-0000-0000-0000-000000000000" as string,
            selectedPatientVersionId: "00000000-0000-0000-0000-000000000000" as string,
            admissionPeriods: [] as IGetPatientAdmissionPeriods[]
        };
    },

    created() {
        this._patientsService = Container.instance.get(PatientService);
        this.patientDocuments = this.$refs.patientDocuments;
        this.options = this.dialogReference.data;
    },

    async mounted() {
        const payload = {
            Application: this.options.application,
            AccountId: this.options.accountId
        };
        this.admissionPeriods = await this._patientsService.getPatientAdmissionPeriodsNoPermission(
            this.options.patientId,
            payload
        );
    },

    watch: {
        selectedPatientVersionId() {
            this.selectedPatientVersionIdChanged();
        }
    },

    methods: {
        selectedPatientVersionIdChanged() {
            this.patientDocuments?.loadFilesList();
        },

        getAdmissionPeriodLabel(period: IGetPatientAdmissionPeriods) {
            let startLabel = moment(period.admissionDate).format("MM/DD/YYYY");
            let end = period.isActive ? null : moment(period.dischargeDate).format("MM/DD/YYYY");
            let endLabel = end ? "- " + end : "";
            return `${startLabel} ${endLabel}${period.isActive ? "(Current Admission Period)" : ""}`;
        },

        uploadDocument(patientId: string, newDocument: IUploadPatientDocumentQuery) {
            return this._patientsService.uploadDocument(patientId, newDocument);
        },

        deleteDocument(patientId: string, documentId: string) {
            return this._patientsService.deleteDocument(patientId, documentId);
        },

        getPatientDocuments(patientId: string) {
            return this._patientsService.getPatientDocuments(patientId, {
                patientVersionId: this.selectedPatientVersionId,
                application: this.options.application,
                accountId: this.options.accountId
            });
        },

        close() {
            this.dialogReference.close("cancel");
        }
    }
});
